<div class="col-md-12 noBottomMargin noPaddingMd-12 borderDiv" >
  <div class="col-md-12 contactBreadCrumbDiv">

  <div class="row">
    <ol class="breadcrumb" style="padding: 10px 20px 0px;">
      <li><a href="#">Home</a></li>
      <li class="active">{{'calculator.pensionCalculator.heading' | translate}} </li>
    </ol>
  <div>
    <div class="row">
      <div class="col-md-12 section">
        <div *ngIf="this.isEmployee">
          <form [formGroup]="pensionCalculatorForm" novalidate (submit)="calculatePension(this.investments, this.pensionCalculatorForm)">
            <div class="card mb-3">
              <div class="card-header bg-transparent">
                <h5 style="margin: 0px;">{{'calculator.pensionCalculator.heading' | translate}}</h5>
              </div>
              <div class="card-body">
                <p class="card-title" style="margin-bottom: 2rem;">{{'calculator.pensionCalculator.intro1' | translate}}<br>
                  {{'calculator.pensionCalculator.intro2' | translate}}<br>
                  {{'calculator.pensionCalculator.intro3' | translate}}</p>
                <div class="row">
                  <div class="col-md-5 col-left-margin" style="margin-bottom: 10px;">
                      <div class="card mb-3">
                        <div class="card-header bg-transparent header-for-dark">
                          <h5 style="margin: 0;">{{'calculator.pensionCalculator.personalData' | translate}}</h5>
                        </div>
                        <div class="card-body" sty>
                          <label class="col-form-label">{{'calculator.pensionCalculator.dob' | translate}} </label>
                          <input class="form-control text-center" type="text" id="dateOfBirth" formControlName="dateOfBirth" placeholder="DD-MM-YYYY" disabled />

                          <label for="total-asset"
                            class="col-form-label collapsed">{{'calculator.pensionCalculator.initbal' | translate}}</label>
                          <input class="form-control text-center" id="total-asset" [textMask]="{mask: currMask}"
                            formControlName="pensionSavingBalance" disabled triggers="focus" />

                          <label for="user-gender" class="col-form-label">{{
                            "calculator.pensionCalculator.gender" | translate
                          }}</label>
                          <select formControlName="userGender" id="user-gender" required>
                            <option value = 1>
                              {{"calculator.pensionCalculator.gender-m" | translate}}
                            </option>
                            <option value = 2>
                              {{"calculator.pensionCalculator.gender-f" | translate}}
                            </option>
                          </select>

                          <label for="current-total-contribution"
                            class="col-form-label">{{'calculator.pensionCalculator.lb' | translate}}</label>
                          <input class="form-control text-center" id="current-total-contribution"
                            [textMask]="{mask: currMask}" formControlName="totalCurrentMonthlyContribution" triggers="focus" />
                          <p class="mandatoryField" style="margin-bottom: 10px;">
                            <i>{{'calculator.pensionCalculator.estcontr' | translate}}</i>
                          </p>

                            <label for="monthly-income"
                            class="col-form-label">{{'calculator.pensionCalculator.sal' | translate}}</label>
                          <input class="form-control text-center" id="monthly-income" [textMask]="{mask: currMask}"
                            formControlName="monthlyIncome" />
                        </div>
                      </div>
                  </div>
                  <div class="col-md-5 col-left-margin col-assumsi" style="margin-bottom: 10px;">
                      <div class="card mb-3">
                        <div class="card-header bg-transparent header-for-dark">
                          <h5 style="margin: 0px;">{{'calculator.pensionCalculator.interhead' | translate}}</h5>
                        </div>
                        <div class="card-body">
                          <label for="assumption-of-average-salary-increase"
                            class="col-form-label">{{'calculator.pensionCalculator.incrSal' | translate}}</label>
                          <input class="form-control text-center" type="text" id="assumption-of-average-salary-increase"
                            (keyup)="handlePercentage($event, pensionCalculatorForm.get('avgSalaryIncYear'))" [textMask]="{mask: numberMask}"
                            formControlName="avgSalaryIncYear" triggers="focus" placeholder="0%"/>

                          <label for="assumption-annual-development-results"
                            class="col-form-label">{{'calculator.pensionCalculator.incrContr' | translate}}</label>
                          <input class="form-control text-center" type="text" id="assumption-annual-development-results"
                            (keyup)="handlePercentage($event, this.annualDevResults)" [textMask]="{mask: numberMask}"
                            formControlName="annualDevResults" triggers="focus" placeholder="0%" />
                          <p class="mandatoryField" style="margin-bottom: 10px;">
                            <i>{{'calculator.pensionCalculator.lbtip' | translate}}</i>
                          </p>

                          <label for="period-until-retirement"
                            class="col-form-label">{{'calculator.pensionCalculator.pan' | translate}}</label>
                          <select class="text-center" formControlName="retirementAge" id="period-until-retirement" required>
                            <option *ngFor="let age of retirementAgeRange" [value]="age">
                              {{ age }}
                            </option>
                          </select>

                          <label for="investment-funds" class="col-form-label">{{
                            "calculator.pensionCalculator.toif"
                            | translate
                            }}</label>

                          <div formArrayName="investments" *ngFor="let investment of pensionCalculatorForm.get('investments').controls; let i = index" class="row">
                            <div [formGroupName]="i" class="col-md-12">
                              <div class="col-md-1 text-left" style="margin-bottom: 0px; padding-top: 1rem">
                                <input formControlName="investmentType" type="checkbox" (change)="toggleInvestment(this.investments, i)"/>
                              </div>
                              <div class="col-md-8 text-left" style="margin-bottom: 0px; padding-right: 1rem">
                                <input formControlName="investmentName" class="form-control text-center" type="text" readonly />
                              </div>
                              <div class="col-md-3 text-center" style="margin-bottom: 0px; margin-top: -1rem; padding-right: 0.5rem;">
                                <select class="text-center" formControlName="investmentPercentage" placeholder="0%" required>
                                  <option *ngFor="let percent of predefinedPercentages" [value]="percent">
                                    {{ percent }}
                                  </option>
                                </select>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <p class="mandatoryField" style="margin-bottom: 10px; margin-top: 25px"><i>
                                {{'calculator.pensionCalculator.riskprofilefield' | translate}}</i></p>
                          </div>
                        </div>
                      </div>
                    <div *ngIf="error" class="alert alert-danger alert-dismissable">
                      {{ errorMessage }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-transparent">
                <div class="row">
                  <div class="col-md-12 text-center" style="margin-bottom: 0px;">
                    <button type="submit" class="btn btn-primary marginTop"
                      [disabled]="!pensionCalculatorForm.valid">{{'calculator.pensionCalculator.cal' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div *ngIf="!this.isEmployee">
          <form [formGroup]="pensionCalculatorEmployerForm" novalidate (submit)="calculatePension(this.investmentsEmployer, this.pensionCalculatorEmployerForm)">
            <div class="card mb-3">
              <div class="card-header bg-transparent">
                <h5 style="margin: 0px;">{{'calculator.pensionCalculator.heading' | translate}}</h5>
              </div>
              <div class="card-body">
                <p class="card-title" style="margin-bottom: 2rem;">{{'calculator.pensionCalculator.intro1' | translate}}<br>
                  {{'calculator.pensionCalculator.intro2' | translate}}<br>
                  {{'calculator.pensionCalculator.intro3' | translate}}</p>
                <div class="row">
                  <div class="col-md-4 col-left-margin" style="margin-bottom: 10px;">
                      <div class="card mb-3">
                        <div class="card-header bg-transparent header-for-dark">
                          <h5 style="margin: 0;">{{'calculator.pensionCalculator.companyData' | translate}}</h5>
                        </div>
                        <div class="card-body" sty>
                          <div class="text-center">
                            <label for="active-participant-upload-data"
                            class="col-form-label">{{'calculator.pensionCalculator.uploadExcl' | translate}}</label>

                            <div class="fileUpload btn btn-primary">
                              <span>Upload</span>
                              <input
                                type="file"
                                (change)="onChange($event)"
                                required
                                class="upload"
                                name="attachFile"
                                ngControl="fileCtrl"
                                [(ngModel)]="attachFile"
                                multiple
                              />
                            </div>
                          </div>

                          <div class="text-center" style="margin-bottom: 2rem;">
                            <label for="excel-template"
                            class="col-form-label">{{'calculator.pensionCalculator.tmpltExcl' | translate}}</label>
                            <br>
                            <a
                              class="text-center" style="font-size: 16px;"
                              (click)="downloadDocument()"
                              download="{{ documentDownloadRequest?.docCaption }}"
                              target="_blank">{{'calculator.pensionCalculator.tmpltExclTitle' | translate}}
                              <span class="bi bi-filetype-csv"></span>
                            </a>
                          </div>

                          <label for="assumption-of-average-salary-increase"
                            class="col-form-label">{{'calculator.pensionCalculator.incrSal' | translate}}</label>
                          <input class="form-control text-center" type="text" id="assumption-of-average-salary-increase"
                            (keyup)="handlePercentage($event, pensionCalculatorEmployerForm.get('avgSalaryIncYear'))" [textMask]="{mask: numberMask}"
                            formControlName="avgSalaryIncYear" triggers="focus" />
                        </div>
                      </div>
                  </div>
                  <div class="col-md-6 col-left-margin col-assumsi" style="margin-bottom: 10px;">
                      <div class="card mb-3">
                        <div class="card-header bg-transparent header-for-dark">
                          <h5 style="margin: 0px;">{{'calculator.pensionCalculator.interhead' | translate}}</h5>
                        </div>
                        <div class="card-body">
                          <label class="col-form-label">{{'calculator.pensionCalculator.effDate' | translate}} </label>
                          <my-date-picker name="mydate"
                            [options]="myDatePickerOptions"
                            formControlName="effectiveDate"
                            placeholder="DD-MM-YYYY"
                            required>
                          </my-date-picker>

                          <label for="investment-funds" class="col-form-label">{{
                            "calculator.pensionCalculator.toif"
                            | translate
                            }}</label>

                          <div formArrayName="investments" class="investment-grid-container">
                            <div class="investment-rows-left">
                              <div *ngFor="let investment of pensionCalculatorEmployerForm.get('investments').controls; let i = index"
                                   [formGroupName]="i"
                                   class="investment-sub-row">

                                <div class="grid-col-chk">
                                  <input formControlName="investmentType" type="checkbox" (change)="toggleInvestment(investmentsEmployer, i)"/>
                                </div>

                                <div class="grid-col-name">
                                  <input formControlName="investmentName" class="small text-center w-100" type="text" readonly />
                                </div>

                                <div class="grid-col-percent">
                                  <select class="small text-center w-100" formControlName="investmentPercentage" placeholder="0%" required>
                                    <option [value]="" hidden></option>
                                    <option *ngFor="let percent of predefinedPercentages" [value]="percent">
                                      {{ percent }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            <div [formGroup]="pensionCalculatorEmployerForm.get('investments').controls[0]" class="investment-row-right-merged">
                              <select class="" formControlName="investmentScenario" required style="height: 165px;">
                                <option value="" hidden></option>
                                <option *ngFor="let scenario of predefinedScenarios" [value]="scenario.value">
                                  {{ scenario.label }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <p class="mandatoryField" style="margin-bottom: 10px;">
                            <i>{{'calculator.pensionCalculator.riskprofilefield' | translate}}</i>
                          </p>
                        </div>
                      </div>
                    <div *ngIf="error" class="alert alert-danger alert-dismissable scrollable-errors">
                      <div *ngFor="let msg of getErrorList()">
                        {{ msg }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer bg-transparent">
                <div class="row">
                  <div class="col-md-12 text-center" style="margin-bottom: 0px;">
                    <button type="submit" class="btn btn-primary marginTop"
                      [disabled]="!pensionCalculatorEmployerForm.valid">{{'calculator.pensionCalculator.cal' | translate}}</button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
          <div class="marginTop" *ngIf="showPensionResult">
            <div class="card mb-3">
              <div class="card-header bg-transparent">
                <h5 style="margin: 0px;">{{'calculator.pensionCalculator.calculateheadeing'|translate}} </h5>
              </div>
              <div class="card-body">
                <div *ngIf="this.isEmployee">
                  <div class="col-md-12 globalMainPadding">
                    <table class="table table-scrollable" style="color:rgb(67, 67, 245)">
                      <tbody>
                      <tr>
                        <td colspan="9"style="color:rgb(67, 67, 245)">
                          {{'calculator.pensionCalculator.result17'|translate}}
                        </td>
                        <td colspan="3" class="rightTextAlign" style="color:rgb(67, 67, 245)">
                          {{ currencySymbol }} {{ calculatedPensionEmployee.initialBalance }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="9" style="color:rgb(67, 67, 245)">
                          {{'calculator.pensionCalculator.result16'|translate}}
                        </td>
                        <td colspan="3" class="rightTextAlign" style="color:rgb(67, 67, 245)">
                          {{ currencySymbol }} {{ calculatedPensionEmployee.totalContributions }}
                        </td>
                      </tr>
                      <tr>
                        <td colspan="6" class="customdiv"></td>
                        <td colspan="2" class="customdiv">{{'calculator.pensionCalculator.result15'|translate}}</td>
                        <td colspan="2" class="customdiv">{{'calculator.pensionCalculator.result14'|translate}}</td>
                        <td colspan="2" class="customdiv">{{'calculator.pensionCalculator.result13'|translate}}</td>
                      </tr>
                      <tr>
                        <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result12'|translate}}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.low.projectedInvestmentReturn }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.middle.projectedInvestmentReturn }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.high.projectedInvestmentReturn }}</td>
                      </tr>
                      <tr>
                        <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result11'|translate}}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.low.balanceBeforeTax }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.middle.balanceBeforeTax }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.high.balanceBeforeTax }}</td>
                      </tr>
                      <tr>
                        <td colspan="12" style="vertical-align: middle; text-align: left; min-height: 50px; padding: 18px; background-color: #f9f9f9; border: 1px solid #ddd;"></td>
                      </tr>
                      <tr>
                        <td colspan="12" class="customdiv">{{'calculator.pensionCalculator.result10'|translate}}</td>
                      </tr>
                      <tr>
                        <td colspan="4" class="customdiv">{{'calculator.pensionCalculator.result8'|translate}}</td>
                        <td colspan="2" class="customdiv">{{ calculatedPensionEmployee.taxes[0] }}%</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.low.tax.amountTaxedAtZeroPercent }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.middle.tax.amountTaxedAtZeroPercent }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.high.tax.amountTaxedAtZeroPercent }}</td>
                      </tr>
                      <tr>
                        <td colspan="4" class="customdiv">{{'calculator.pensionCalculator.result9'|translate}}</td>
                        <td colspan="2" class="customdiv">{{ calculatedPensionEmployee.taxes[1] }}%</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.low.tax.amountTaxedAtFivePercent }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.middle.tax.amountTaxedAtFivePercent }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.high.tax.amountTaxedAtFivePercent }}</td>
                      </tr>
                      <tr>
                        <td colspan="12" style="vertical-align: middle; text-align: left; min-height: 50px; padding: 18px; background-color: #f9f9f9; border: 1px solid #ddd;"></td>
                      </tr>
                      <tr>
                        <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result7'|translate}}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.low.balanceAfterTax }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.middle.balanceAfterTax }}</td>
                        <td colspan="2" class="customdiv">{{ currencySymbol }} {{ calculatedPensionEmployee.scenarios.high.balanceAfterTax }}</td>
                      </tr>
                      <tr>
                        <td colspan="12" style="vertical-align: middle; text-align: left; min-height: 50px; padding: 18px; background-color: #f9f9f9; border: 1px solid #ddd;"></td>
                      </tr>
                      <tr>
                        <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result6'|translate}}</td>
                        <td colspan="2" class="customdiv">{{ calculatedPensionEmployee.scenarios.low.replacementRatioPercent }}%</td>
                        <td colspan="2" class="customdiv">{{ calculatedPensionEmployee.scenarios.middle.replacementRatioPercent }}%</td>
                        <td colspan="2" class="customdiv">{{ calculatedPensionEmployee.scenarios.high.replacementRatioPercent }}%</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div *ngIf="!this.isEmployee">
                  <div class="col-md-12 globalMainPadding">
                    <table class="table table-scrollable" style="color:rgb(67, 67, 245)">
                      <tbody>
                        <tr>
                          <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result18'|translate}}</td>
                          <td colspan="6" class="customdiv">{{ calculatedPension.totalEmployees }} {{'calculator.pensionCalculator.result26'|translate}}</td>
                        </tr>
                        <tr>
                          <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result19'|translate}}</td>
                          <td colspan="6" class="customdiv">{{ currencySymbol }} {{ formatFullNumber(calculatedPension.presentValueBenefitObligation) }}</td>
                        </tr>
                        <tr>
                          <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result20'|translate}}</td>
                          <td colspan="6" class="customdiv">{{ currencySymbol }} {{ formatFullNumber(calculatedPension.currentServiceCost) }}</td>
                        </tr>
                        <tr>
                          <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result21'|translate}}</td>
                          <td colspan="6" class="customdiv">{{ calculatedPension.averageFutureService }} / {{'calculator.pensionCalculator.result25'|translate}}</td>
                        </tr>
                        <tr>
                          <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result22'|translate}}</td>
                          <td colspan="6" class="customdiv">{{ currencySymbol }} {{ formatFullNumber(calculatedPension.totalMonthlySalary) }}</td>
                        </tr>
                        <tr>
                          <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result23'|translate}}</td>
                          <td colspan="6" class="customdiv">{{ currencySymbol }} {{ formatFullNumber(calculatedPension.totalYearlySalary) }}</td>
                        </tr>
                        <tr>
                          <td colspan="6" class="customdiv">{{'calculator.pensionCalculator.result24'|translate}}</td>
                          <td colspan="6" class="customdiv">{{ currencySymbol }} {{ formatFullNumber(calculatedPension.totalBenefitAtRetirement) }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="col-md-12 noBottommargin">
                  <p class="smallFont"><i>**{{'calculator.pensionCalculator.resultnote1'|translate}}</i></p>
                  <p class="smallFont"><i>**{{'calculator.pensionCalculator.resultnote2'|translate}}</i></p>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
  </div>
  </div>
</div>
